import {FC, useMemo} from 'external/react'

type AvatarProps = {
	name?: string,
	lastname?: string,
	size?: 'sm' | 'md' | 'lg'
}

const classNameBySize = {
	'sm': 'circle-avatar-sm text-center mx-auto',
	'md': 'circle-avatar-md text-center mx-auto',
	'lg': 'circle-avatar-lg text-center mx-auto mb-1 mt-1'
}

const Avatar: FC<AvatarProps> = props => {
	const { name = '', lastname = '', size = 'lg' } = props
	const initials = useMemo(() => `${name.charAt(0)}${lastname.charAt(0)}`.toUpperCase(), [name, lastname])
	const className = useMemo(() => classNameBySize[size], [size])

	return (
		<div className={className}>
			<span>{initials}</span>
		</div>
	)
}

export default Avatar;